import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  light: {
    name: 'Açık Tema',
    gradient: 'from-white via-gray-50 to-white',
    accent: 'red',
    accentLight: 'red-100',
    icon: '☀️'
  },
  dark: {
    name: 'Koyu Tema',
    gradient: 'from-slate-950 via-slate-900 to-slate-950',
    accent: 'red',
    accentLight: 'red-900',
    icon: '🌙'
  }
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    try {
      return localStorage.getItem('zeha-theme') || 'light';
    } catch {
      return 'light';
    }
  });

  const isDark = currentTheme === 'dark';

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
      document.body.style.backgroundColor = '#020617'; // slate-950
    } else {
      document.documentElement.classList.remove('dark');
      document.body.style.backgroundColor = '#ffffff';
    }
    try {
      localStorage.setItem('zeha-theme', currentTheme);
    } catch {}
  }, [currentTheme, isDark]);

  const toggleTheme = () => {
    setCurrentTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <ThemeContext.Provider value={{ 
      isDark, 
      toggleTheme, 
      currentTheme,
      theme: themes[currentTheme],
      allThemes: themes
    }}>
      {children}
    </ThemeContext.Provider>
  );
};
